// Горната лента на листа „Инвентаризация" (`WorksheetTopBand`, както при
// „Доставка"): назад · заглавие и реквизитите на един ред — Дата · Склад ·
// Бележка / причина. Смяната на склада нулира преброеното (другият склад има
// други наличности) — решава страницата.
import type { ComponentProps } from "react";
import { DatePicker, Input, Select } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import type { Warehouse } from "../../../../api/inventory";
import { WorksheetField, WorksheetTopBand } from "../../components/worksheet/WorksheetTopBand";

type Props = {
  // назад · заглавие
  band: Omit<ComponentProps<typeof WorksheetTopBand>, "children">;
  date: string; // YYYY-MM-DD
  onDateChange: (date: string) => void;
  warehouseId: number | null;
  onWarehouseChange: (warehouseId: number) => void;
  warehouses: Warehouse[];
  reason: string;
  onReasonChange: (value: string) => void;
};

export const StocktakeWorksheetHeader = ({
  band,
  date,
  onDateChange,
  warehouseId,
  onWarehouseChange,
  warehouses,
  reason,
  onReasonChange,
}: Props) => {
  const { t } = useTranslation();
  return (
    <WorksheetTopBand {...band}>
      <WorksheetField label={t("inventoryPage.fieldStocktakeDate")} size="sm">
        <DatePicker
          value={date ? dayjs(date) : null}
          onChange={(d) => onDateChange(d ? d.format("YYYY-MM-DD") : "")}
          format="DD.MM.YYYY"
          allowClear={false}
          className="w-full"
        />
      </WorksheetField>
      <WorksheetField label={t("inventoryPage.fieldWarehouse")}>
        <Select
          value={warehouseId ?? undefined}
          onChange={(v) => onWarehouseChange(v as number)}
          placeholder={t("inventoryPage.fieldWarehousePh")}
          options={warehouses.map((w) => ({ value: w.id, label: w.name }))}
          className="w-full"
        />
      </WorksheetField>
      <WorksheetField label={t("inventoryPage.fieldStocktakeReason")} size="grow">
        <Input
          value={reason}
          placeholder={t("inventoryPage.stocktakeReasonPh")}
          onChange={(e) => onReasonChange(e.target.value)}
          className="w-full"
        />
      </WorksheetField>
    </WorksheetTopBand>
  );
};

export default StocktakeWorksheetHeader;
